<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const emit = defineEmits(['update:modelValue', 'update:focused']);
const { t } = useI18n();
defineProps({
    hideLabel: {
        type: Boolean,
        default: false
    }
});

const selected = ref([]);
const types = [
    {
        title: t('Recoger'),
        value: 'Recoger'
    },
    {
        title: t('Dejar'),
        value: 'Dejar'
    },
    {
        title: t('Recoger y Dejar'),
        value: 'Recoger y Dejar'
    }
];
</script>

<template>
    <v-select
        v-model="selected"
        :items="types"
        :label="hideLabel ? '' : $t('Operation Type')"
        density="compact"
        hide-details
        clearable
        persistent-clear
        @update:modelValue="emit('update:modelValue', selected)"
        @update:focused="(state) => emit('update:focused', state)"
    >
        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </v-select>
</template>
